<smart-cart-form-editor-shell [formGroup]="formGroup">
  <smart-cart-form-token-section [token]="usageToken"></smart-cart-form-token-section>

  <pdq-card variant="popover" color="white">
    <div class="card">
      <div class="card__header">
        <pdq-heading element="h5">Appearance</pdq-heading>
      </div>
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <pdq-input-color [formControl]="formGroup.controls.backgroundColor" label="Background Color"></pdq-input-color>
        <div class="field">
          <span class="field__label">Padding</span>
          <!-- useOverlay renders the option list in a body-level CDK overlay. Inline, it's an absolutely
               positioned sibling at z-index 1 and the Bottom Border checkbox's own positioned checkmark
               paints over it. -->
          <pdq-dropdown
            [formControl]="formGroup.controls.padding"
            [options]="paddingOptions"
            [useOverlay]="true"
            fullWidth="true"></pdq-dropdown>
        </div>
        <div class="field" [formGroup]="formGroup.controls.bottomBorder">
          <pdq-checkbox
            [formControl]="formGroup.controls.bottomBorder.controls.enabled"
            label="Bottom border"
            labelSize="small"></pdq-checkbox>
          @if (formGroup.controls.bottomBorder.controls.enabled.value) {
            <pdq-input-color [formControl]="formGroup.controls.bottomBorder.controls.color"></pdq-input-color>
          }
        </div>
      </div>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card">
      <div class="card__header">
        <pdq-heading element="h5">Title</pdq-heading>
      </div>
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <pdq-radio-group [formControl]="formGroup.controls.title.controls.mode" label="Title mode" alignment="vertical">
          <pdq-radio-button value="text" text="Text"></pdq-radio-button>
          <pdq-radio-button value="logo" text="Logo"></pdq-radio-button>
        </pdq-radio-group>
        @if (formGroup.controls.title.controls.mode.value === 'text') {
          <div class="field">
            <span class="field__label">Title</span>
            <rich-textarea
              [initialContent]="formGroup.controls.title.controls.text.value"
              (contentChange)="onTitleTextChange($event)"
              [enableLinkInsert]="true"
              [placeholder]="'My Cart {item_count}'"></rich-textarea>
            <span class="field__hint">Dynamic field available - {{ '{item_count}' }}</span>
          </div>
          <pdq-input-color
            [formControl]="formGroup.controls.title.controls.textColor"
            label="Text Color"
            [clearable]="true"
            clearTooltip="Use the theme's colour"
            (cleared)="formGroup.controls.title.controls.textColor.setValue('')"></pdq-input-color>
        } @else {
          <div class="field">
            <span class="field__label">Logo image</span>
            <pdq-image-upload-card
              variant="upload-area"
              thumbnailFit="contain"
              [imageUrl]="formGroup.controls.title.controls.logoUrl.value ?? ''"
              [allowedImageTypes]="allowedLogoImageTypes"
              [maxFileSizeBytes]="maxLogoFileSizeBytes"
              [isLoading]="uploadingLogo"
              idleTitle="Drop your image file here"
              idleLinkText="or click to browse"
              formatHint="PNG, SVG, JPG"
              [validationErrorMessage]="logoValidationError"
              (onImageChange)="onLogoChanged($event)"
              (onValidationFailure)="onLogoValidationFailed($event)">
            </pdq-image-upload-card>
          </div>
        }
      </div>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card">
      <div class="card__header">
        <pdq-heading element="h5">Close button</pdq-heading>
      </div>
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <pdq-input-color
          [formControl]="formGroup.controls.closeButton.controls.iconColor"
          label="Icon Color"></pdq-input-color>
        <pdq-input-color
          [formControl]="formGroup.controls.closeButton.controls.backgroundColor"
          label="Background Color"></pdq-input-color>
        <pdq-input-color
          [formControl]="formGroup.controls.closeButton.controls.hoverColor"
          label="Hover Color"></pdq-input-color>
        <div class="field">
          <span class="field__label">Icon size</span>
          <pdq-dropdown
            [formControl]="formGroup.controls.closeButton.controls.iconSize"
            [options]="iconSizeOptions"
            fullWidth="true"></pdq-dropdown>
        </div>
      </div>
    </div>
  </pdq-card>

  <smart-cart-form-custom-code
    [enabledControl]="formGroup.controls.customCode.controls.enabled"
    [codeControl]="formGroup.controls.customCode.controls.code"
    [defaultCode]="starterTemplate"
    [variables]="customCodeVariables"></smart-cart-form-custom-code>
</smart-cart-form-editor-shell>
